import Vue from 'vue';

Vue.component('tank-index', () =>
    import(/* webpackChunkName: 'tank-index' */ './tank-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/tank/index.js